// Those constants are used to configure the rate limit options for the application.
const RATE_LIMIT_CONFIG = {
  FULL_RATE_SIMULTANEOUS_HOSTS: 500,
  SLOW_SCAN_SIMULTANEOUS_HOSTS: 30,
  FULL_RATE_REQUESTS_PER_HOST: 250,
  SLOW_SCAN_REQUESTS_PER_HOST: 25,
};

export const RATE_LIMIT_FIXED_VALUES = {
  FULL_RATE_PROXY_VALUE: Number.POSITIVE_INFINITY,
  FULL_RATE_SIMULTANEOUS_HOSTS: RATE_LIMIT_CONFIG.FULL_RATE_SIMULTANEOUS_HOSTS,
  REDUCED_SCANNING_SIMULTANEOUS_HOSTS:
    (RATE_LIMIT_CONFIG.FULL_RATE_SIMULTANEOUS_HOSTS +
      RATE_LIMIT_CONFIG.SLOW_SCAN_SIMULTANEOUS_HOSTS) /
    2,
  SLOW_SCAN_SIMULTANEOUS_HOSTS: RATE_LIMIT_CONFIG.SLOW_SCAN_SIMULTANEOUS_HOSTS,
  FULL_RATE_REQUESTS_PER_HOST: RATE_LIMIT_CONFIG.FULL_RATE_REQUESTS_PER_HOST,
  REDUCED_SCANNING_REQUESTS_PER_HOST:
    (RATE_LIMIT_CONFIG.FULL_RATE_REQUESTS_PER_HOST +
      RATE_LIMIT_CONFIG.SLOW_SCAN_REQUESTS_PER_HOST) /
    2,
  SLOW_SCAN_REQUESTS_PER_HOST: RATE_LIMIT_CONFIG.SLOW_SCAN_REQUESTS_PER_HOST,
};

export interface RateLimitOption {
  title: string;
  description: string;
  min?: number;
  max?: number;
  value?: number;
  isCustomOption?: boolean;
  isFullRateOption?: boolean;
}
